import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=1e4ae5fb&scoped=true&"
import script from "./Simple.vue?vue&type=script&lang=js&"
export * from "./Simple.vue?vue&type=script&lang=js&"
import style0 from "./Simple.vue?vue&type=style&index=0&id=1e4ae5fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4ae5fb",
  null
  
)

export default component.exports